<template>
    <div class="warpper flex-sub">
        <div class="page-menu flex align-center justify-between">
            <router-link :to="item.page" class="menu" :class="{active:navIndex === item.value}" v-for="(item,index) in menus" :key="index">
                {{item.label}}
            </router-link>
        </div>
        <div class="content-container">
            <router-view @setIndex="getIndex(arguments)" class="content"></router-view>
        </div>
    </div>
</template>

<script>
    import {vipMenus} from '@/utils/const'
    export default {
        name: "vip",
        components: {},
        data() {
            return {
                navIndex: 0,
                menus: vipMenus
            }
        },
        created() {
        },
        methods: {
            getIndex(data) {
                this.navIndex = data[0]
                this.$emit('setIndex', [5], '会员中心-' + data[1])
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        .page-menu {
            .menu {
                width: 312px;
                height: 61px;
                background-color: #ffffff33;
                border-radius: 10px;
                font-size: 22px;
                font-weight: bold;
                line-height: 61px;
                text-align: center;
                color: #ffffff;
                cursor: pointer;
                &.active{
                    background-color: #ffffff;
                    color: #ff9600;
                    position: relative;
                    &:before {
                        position: absolute;
                        bottom: -8px;
                        border-left: 8px solid transparent;
                        border-top: 8px solid #ffffff;
                        border-right: 8px solid transparent;
                        left: 50%;
                        transform: translateX(-50%);
                        content: '';
                    }
                }
            }
        }
        .content-container {
            display: flex;
            flex-direction: column;
            width:100%;
            margin-top: 20px;
            flex: 1;
            .content {
                display: flex;
                flex-direction: column;
                flex: 1;
            }
        }
    }
</style>